export default "__VITE_ASSET__1GFXsq9Y__"